(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get the key values from the section
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swipers
     ************/

    section.querySelectorAll(".productVisualWrap").forEach((element) => {

        const productSwiper = new Swiper(element.querySelector(".productVisualSwiper"), {
            slidesPerView: 1.3,
            spaceBetween: 0,
            autoHeight: true,
            navigation: {
                nextEl: element.querySelector(".productVisualSwiperNext"),
                prevEl: element.querySelector(".productVisualSwiperPrev"),
            },
            breakpoints: {
                1100: {
                    spaceBetween: 20,
                    slidesPerView: 1,
                }
            },
            on: {
                slideChange: function () {
                    if (!element.querySelector(".productVisualSwiperSlide")) {
                        return;
                    }
                    // update the thumbnail active class
                    element.querySelector(".productVisualThumbsSlide.active").classList.remove("active");
                    element.querySelectorAll(".productVisualThumbsSlide")[this.realIndex].classList.add("active");

                    // pause all videos
                    element.querySelectorAll(".productVisualSwiperSlide video").forEach(video => {
                        video.pause();
                    });
                }
            }
        });

        // play video on slide play click
        element.querySelectorAll(".productVisualSwiperSlide").forEach(slide => {
            slide.addEventListener("click", function () {
                // get video
                const video = this.closest(".productVisualSwiperSlide").querySelector("video");

                if (!video) {
                    return;
                }

                // remove play button if it hasn't already been removed
                this.querySelector(".productVisualSwiperSlidePlay")?.remove();

                // show controls
                video.controls = true;

                // play video
                video.play();
            });
        });

        // change slide on thumbnail click
        element.querySelectorAll(".productVisualThumbsSlide").forEach(slide => {
            slide.addEventListener("click", function () {
                // change slide
                productSwiper.slideTo(this.dataset.index - 1);
            });
        });

    })


    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!section.querySelector(`.productSellingLabelInput[value="sub"]:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productSellingLabelBodySelect').value);
    }

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productOptionsItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATC").textContent = "Not Available";
            return;
        }

        /**************
         Variant Gallery
         ***************/

            // show the correct gallery based on the variant selected
        let multipleGalleriesExist = section.querySelectorAll('.productVisualWrap').length > 1;
        if (multipleGalleriesExist) {
            section.querySelectorAll('.productVisualWrap').forEach(gallery => {
                if (parseInt(gallery.dataset.id) === activeVariant.id) {
                    gallery.classList.add('active');
                } else {
                    gallery.classList.remove('active');
                }
            })
        }

        /**************
         Variant Dropdowns
         ***************/
        section.querySelectorAll('.productDropsDropdown.variant').forEach(dropdown => {
            if (parseInt(dropdown.dataset.id) === activeVariant.id) {
                dropdown.classList.add('active');
            } else {
                dropdown.classList.remove('active');
            }
        })


        /**************
         Price
         ***************/

        // if there's a subscription we need to update both prices
        if (product.selling_plan_groups.length > 0) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productSellingLabelBodyPriceCompare");
            const reals = section.querySelectorAll(".productSellingLabelBodyPriceReal");

            // Destructure them for clarity:
            // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
            const [oneTimeCompare, subCompare] = compares;
            const [oneTimeReal, subReal] = reals;

            const allocationPrice = activeVariant.selling_plan_allocations[0].price;

            // Update subscription prices
            if (activeVariant.price > allocationPrice) {
                subCompare.textContent = price(activeVariant.price * quantity, true);
            }
            if (activeVariant.compare_at_price > allocationPrice) {
                subCompare.textContent = price(activeVariant.compare_at_price * quantity, true);
            }
            subReal.textContent = price(allocationPrice * quantity, true);

            // Update one-time purchase prices
            if (activeVariant.compare_at_price > activeVariant.price) {
                oneTimeCompare.textContent = price(activeVariant.compare_at_price * quantity, true);
            }
            oneTimeReal.textContent = price(activeVariant.price * quantity, true);


        } else {
            // Non-subscription scenario
            const compareEl = section.querySelector(".productSellingLabelBodyPriceCompare");
            const realEl = section.querySelector(".productSellingLabelBodyPriceReal");

            if (activeVariant.compare_at_price > activeVariant.price) {
                compareEl.textContent = price(activeVariant.compare_at_price * quantity, true);
            }
            realEl.textContent = price(activeVariant.price * quantity, true);
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelectorAll('.productATC').forEach(btn => {
                btn.classList.remove('OOS');
                btn.textContent = "Add To Cart";
            })

        } else {
            section.querySelectorAll('.productATC').forEach(btn => {
                btn.classList.add('OOS');
                btn.textContent = "PRE-ORDER";
            })
        }

        // FREE SHIPPING
        let threshold = parseInt(section.querySelector('.productShipping').dataset.threshold)
        section.querySelector('.productShipping').classList.remove("active");
        if (threshold > 0) {
            section.querySelector('.productShipping').classList.add("active");
            let totalPrice = isSubscription() ? activeVariant.selling_plan_allocations[0].price : activeVariant.price;
            let difference = threshold * 100 - (totalPrice * quantity);
            section.querySelector(".productShipping").textContent = `Spend ${price(difference)} more and get free shipping!`;

            if (difference <= 0) {
                section.querySelector(".productShipping").textContent = "You get free shipping!"
            }
        }

        /*************
         Update Sticky
         *********/
        section.querySelector('.productStickyPriceCompare').textContent = ``;
        section.querySelector('.productStickyPriceReal').classList.remove("sale");
        if (activeVariant.compare_at_price > activeVariant.price) {
            section.querySelector('.productStickyPriceReal').classList.add("sale");

            section.querySelector('.productStickyPriceCompare').textContent = price(activeVariant.compare_at_price * quantity, true);
        }
        if (isSubscription()) {
            let allocationPrice = activeVariant.selling_plan_allocations[0].price;

            if (activeVariant.compare_at_price > allocationPrice) {
                section.querySelector('.productStickyPriceReal').classList.add("sale");
                section.querySelector('.productStickyPriceCompare').textContent = price(activeVariant.compare_at_price * quantity, true);
            }
        }
        section.querySelector('.productStickyPriceReal').textContent = price((isSubscription() ? activeVariant.selling_plan_allocations[0].price : activeVariant.price) * quantity, true);


        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelectorAll('.productQuantityBtn.minus').forEach(button => {
        button.addEventListener("click", function () {
            if (quantity === 1) {
                return;
            }
            quantity--;
            section.querySelectorAll(".productQuantityValue").forEach(el => {
                el.textContent = quantity;
            })
            updateProduct();
        });
    })


    // plus
    section.querySelectorAll('.productQuantityBtn.plus').forEach(button => {
        button.addEventListener("click", function () {
            quantity++;
            section.querySelectorAll(".productQuantityValue").forEach(el => {
                el.textContent = quantity;
            })
            updateProduct();
        });
    })

    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // OOS
        if (section.querySelector('.productATC').classList.contains('OOS')) {

            // Klaviyo OOS
            Swal.fire({
                title: `Notify Me When Available`,
                input: "email",
                inputPlaceholder: "Email",
                showCancelButton: true,

                cancelButtonText: "Cancel",
                confirmButtonText: "Notify Me",
                showLoaderOnConfirm: true,
                preConfirm: async () => {
                    let email = Swal.getInput().value;
                    await sendKlaviyoBackInStockRequest(email, activeVariant.id);
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                // if the user confirmed the skip, show success message and reload the page
                if (result.isConfirmed) {
                    Swal.fire({
                        title: `Success`,
                        text: `We'll notify you when the product is back in stock.`,
                        icon: "success"
                    })
                }
            });


            return
        }


        // add loading animation to both buttons
        section.querySelectorAll('.productATC').forEach(button => {
            button.classList.add('loading');
        })

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = parseInt(section.querySelector('.productSellingLabelBodySelect').value)
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelectorAll('.productATC').forEach(button => {
            button.classList.remove('loading');
        })
        // open cart
        await openCart();
    }

    section.querySelectorAll(".productATC").forEach((element) => {
        element.addEventListener("click", addToCart);
    })

    /**************
     Upsells
     ***************/
    let upsellsExist = section.querySelector('.productUpsells') || false;
    if (upsellsExist) {

        // upsell swiper
        new Swiper(section.querySelector(".productUpsellsSwiper"), {
            slidesPerView: 1,
            spaceBetween: 16,
            pagination: {
                el: section.querySelector(".productUpsellsSwiperPag"),
                clickable: true,
            },
            navigation: {
                nextEl: section.querySelector(".productUpsellsSwiperNext"),
                prevEl: section.querySelector(".productUpsellsSwiperPrev"),
            },
            breakpoints: {
                1275: {
                    slidesPerView: 1.2,
                }
            }
        });

        // upsell ATC
        section.querySelectorAll('.productUpsellsSwiperSlideATC').forEach(button => {
            button.addEventListener('click', async function () {
                button.classList.add('loading')

                // add to cart
                await addProduct({
                    id: parseInt(button.dataset.id),
                    quantity: 1
                })

                button.classList.remove('loading')

                // open cart
                await openCart();
            })
        })
    }


    // setup Dropdowns
    section.querySelectorAll(".productDropsDropdownTop")?.forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    // Sticky ATC
    // wait to allow the page to load before setting up the sticky ATC
    setTimeout(function () {
        let isVisible = false;
        const productFormATC = section.querySelector(".ATCTarget");
        const stickyATC = section.querySelector(".productSticky");

        // listen if the original ATC button is scrolled off screen
        window.addEventListener('scroll', function () {
            const scrollTop = window.scrollY;
            const buttonOffsetTop = productFormATC.offsetTop;

            if (scrollTop > buttonOffsetTop && !isVisible) {
                stickyATC.classList.add('active');
                isVisible = true;
            } else if (scrollTop <= buttonOffsetTop && isVisible) {
                stickyATC.classList.remove('active');
                isVisible = false;
            }
        })

        // update the footer padding to make room for the sticky ATC
        let footerPaddingBottom = parseInt(getComputedStyle(document.querySelector("footer")).paddingBottom);
        let stickyATCHeight = stickyATC.getBoundingClientRect().height;
        document.querySelector("footer").style.paddingBottom = `${footerPaddingBottom + stickyATCHeight}px`;
    }, 300);

}());